<template>
  <div>
    <!-- Switch -->
    <v-switch
      v-model="tempValue"
      :label="label"
      :disabled="disabled"
      hide-details
      @change="onToggle"
    />

    <!-- Confirm Dialog -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400">
      <v-card>
        <v-card-title class="text-h6">
          {{ confirmTitle }}
        </v-card-title>

        <v-card-text>
          {{ confirmText }}
          <strong>{{ tempValue ? onText : offText }}</strong>
          ?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="cancel">
            {{ cancelText }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm">
            {{ confirmButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ConfirmSwitch',

  props: {
    value: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },

    /* dialog texts */
    confirmTitle: {
      type: String,
      default: 'Confirm'
    },
    confirmText: {
      type: String,
      default: 'Are you sure you want to'
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    onText: {
      type: String,
      default: 'enable'
    },
    offText: {
      type: String,
      default: 'disable'
    }
  },

  data () {
    return {
      dialog: false,
      tempValue: this.value
    }
  },

  watch: {
    value (val) {
      this.tempValue = val
    }
  },

  methods: {
    onToggle () {
      this.dialog = true
    },

    cancel () {
      this.tempValue = this.value
      this.dialog = false
    },

    confirm () {
      this.dialog = false
      this.$emit('input', this.tempValue) // for v-model
      this.$emit('confirm', this.tempValue)
    }
  }
}
</script>
